import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';

const CoverageOptionsWrapper = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & BoxProps) => {
  return (
    <Box display="flex" alignItems="center" gap="1rem" {...props}>
      {children}
    </Box>
  );
};

export default CoverageOptionsWrapper;
